<div class="card-header">
  <app-breadcrumb currentPage="handmatig rekening toevoegen"></app-breadcrumb>
</div>
<div class="card-body">
  <form [formGroup]="formGroup" class="form card-body-modal">
    <p>hier komt een korte uitleg waarom deze pagina zo speciaal is.</p>

    <div [ngClass]="{ 'input-error': submitted && f.accountNumber.errors }">
      <label class="form-label" for="accountNumber">IBAN</label>
      <input formControlName="accountNumber" class="extended" id="accountNumber" type="text">
      <div class="errors">
        <div *ngIf="f.accountNumber.errors?.required">rekeningnummer is verplicht</div>
        <div *ngIf="f.accountNumber.errors?.validAccountNumber">rekeningnummer is geen correct iban</div>
      </div>
    </div>

    <div [ngClass]="{ 'input-error': submitted && f.accountCategoryId.errors }">
      <label class="form-label"
             for="accountCategoryId">type rekening</label>
      <app-select [options]="accountCategories"
                  formControlName="accountCategoryId"
                  [extended]="true"
                  id="accountCategoryId"
                  labelIndex="name"
                  valueIndex="id"></app-select>
      <div class="errors">
        <div *ngIf="f.accountCategoryId.errors?.required">type rekening is verplicht</div>
      </div>
    </div>

    <div [ngClass]="{ 'input-error': submitted && f.openingBalance.errors }">
      <label class="form-label" for="openingBalance">startsaldo (per {{ startDate?.value }})</label>
      <div class="euro-field">
        <input formControlName="openingBalance" class="extended" id="openingBalance" type="text">
      </div>
      <div class="errors">
        <div *ngIf="f.openingBalance.errors?.required">startsaldo is verplicht</div>
        <div *ngIf="f.openingBalance.errors?.pattern">het verzoek een punt te gebruiken in plaats van een komma</div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <button (click)="back()" class="btn arrow-left btn-left">annuleer</button>
    <button (click)="submit()" class="btn accent inverted plus ">opslaan</button>
    <div class="spacer-small"></div>
  </form>
</div>
